import React, { useEffect, useCallback, useState} from 'react';
import {AUDIO_FX, MIDI_FX} from 'constants/effect-types.js';
import {
    setSelectedMixEffect,
} from 'actions/index.js';
import MidiEffectComponent from 'components/effects/MidiEffectComponent.js';
import EffectComponent from 'components/effects/EffectComponent.js';
import Dropdown from 'react-dropdown';
import {effectOptions, getEffectOption, initializeEffect} from 'components/effects/constants.js';
import EffectOption from './EffectOption.js';
import {connect} from 'react-redux';

const TrackEffects = ({track, effects, showEffect, selectedEffect, selectedMidiEffect, clearSelectedEffect}) => { 
    let [value, setValue] = useState(undefined);

    const handleChooseEffect = useCallback((e) => {
        let effect = initializeEffect(e.value, track.sequencerEngine);
        effect.enable(true);
        if (effect.wetParameter) {
            effect.wetParameter.set(1);
        }
        track.effectsChain.addEffect(effect);
        setValue(e.value);
        return false;
    }, [setValue, track]);

    const moveEffectTo = useCallback((from, to) => {
        if (!track.effects[from] || !track.effects[to]) {
            return;
        }
        track.moveEffectTo(from, to);
        setValue({from, to});
    }, [track, setValue]);

    const moveMidiEffectTo = useCallback((from, to) => {
        if (!track.midiEffects.effects[from] || !track.midiEffects.effects[to]) {
            return;
        }
        track.moveMidiEffectTo(from, to);
        setValue({from, to});
    }, [track, setValue]);

    const onDeleteEffect = useCallback((type) => {
        clearSelectedEffect(type);
        setValue(type);
    }, []);

    
    let effect = '';
    if (showEffect) {
        effect = selectedEffect ?
           <EffectComponent
             sequencerEngine={track.sequencerEngine}
             onDeleteEffect={() => onDeleteEffect(AUDIO_FX)}
             track={track}
             compact={true}
             isDraggable={false}
             effect={selectedEffect}
             send={undefined}/>  : 
           selectedMidiEffect ?
           <MidiEffectComponent
             isDraggable={false}
             sequencerEngine={track.sequencerEngine}
             onDeleteEffect={() => onDeleteEffect(MIDI_FX)}
             effect={selectedMidiEffect}
             track={track}
             compact={true}
           /> : '';
    }

    return (
        <div className="track-effects">
          {effect}
          <div className="effects-container">
            <Dropdown
              className='send-effects-dropdown'
              options={effectOptions}
              onChange={handleChooseEffect}
              placeholder="Audio FX" />
            {track.midiEffects && track.midiEffects.effects.map(
                (effect, i) => 
                    <EffectOption
                      key={effect.id}
                      track={track}
                      currentSubSequence={track.subSequence}
                      effectType={"MIDI_FX"}
                      moveEffectTo={moveMidiEffectTo}
                      effectNumber={i}
                      effect={effect}/>)}
            {track.effects.map(
                (effect, i) =>
                    <EffectOption
                      key={effect.id}
                      track={track}
                      currentSubSequence={track.subSequence}
                      effectType={"AUDIO_FX"}
                      moveEffectTo={moveEffectTo}
                      effectNumber={i}
                      effect={effect}/>)}
          </div>
        </div>);
}

const mapStateToProps = (state, props) => {
    let track = props.track;
    if (track && track.tracks && track.tracks[0]) {
        track = track.tracks[0].track;
    }
    
    let subId = track && track.subSequence.id;
  return {
        selectedEffect: track !== undefined && state.mix.selectedTrackEffects[subId] &&
            state.mix.selectedTrackEffects[subId][track.id],
        selectedMidiEffect: track !== undefined && state.mix.selectedTrackMidiEffects[subId] &&
            state.mix.selectedTrackMidiEffects[subId][track.id]
  };
};

const mapDispatchToProps = (dispatch, props) => {
    let track = props.track;
    if (track && track.tracks && track.tracks[0]) {
        track = track.tracks[0].track;
    }
    
    let subId = track && track.subSequence.id;
  return {
      clearSelectedEffect: (type) => 
            dispatch(
                setSelectedMixEffect(subId, track.id, undefined, type, undefined))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackEffects);
